import React, {useState, useRef, useEffect} from 'react';
import {useLocation, useNavigate} from 'react-router-dom';

import '@aws-amplify/ui-react/styles.css';
import '../App.css';
import AppLayout from "@awsui/components-react/app-layout";
import FormField from "@awsui/components-react/form-field";
import Alert from "@awsui/components-react/alert";
import Container from "@awsui/components-react/container";
import Header from "@awsui/components-react/header";
import SideNavigation from '@awsui/components-react/side-navigation';
import Button from "@awsui/components-react/button";
import TokenGroup from "@awsui/components-react/token-group";
import TopNavigation from "@awsui/components-react/top-navigation"
import SpaceBetween from "@awsui/components-react/space-between";
import ProgressBar from "@awsui/components-react/progress-bar";
import { Amplify, Auth, Storage} from 'aws-amplify';
import {Authenticator, Text, Image, View, useTheme} from '@aws-amplify/ui-react';
import HelpPanel from "@awsui/components-react/help-panel";
import Icon from "@awsui/components-react/icon";
import awsconfig from '../aws-exports';
import { CognitoUser } from 'amazon-cognito-identity-js';
import { Navigate } from "react-router-dom";
import {Login, OTPPAGE, ResetPassword, ForgotPassword} from "./Login";
import Lambda from 'aws-sdk/clients/lambda'; // npm install aws-sdk

// import "bootstrap/dist/css/bootstrap.min.css"
Amplify.configure(awsconfig);
// Auth.configure(awsconfig);

Auth.configure({authenticationFlowType: 'CUSTOM_AUTH'});
var loggedIn = false;
var userName = "";
var userOTP;
var time;
var identityID = "";
var currTime = Date.now();
var checkTimer = false;
var inactivityTime = function () { 
    resetTimer()
    window.onload = resetTimer;
    // DOM Events
    document.onmousemove = resetTimer;
    document.onkeydown = resetTimer;
    function logout() {
        // const location = useLocation();
        //  const { state } = useLocation();
       //let {state} =useLocation(); let {loggedIn, userName, authenticated} =state;
        if (loggedIn){
        //location.href = 'logout.html
            Auth.currentAuthenticatedUser({
                bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
            })
                .then((user) => {
                    Auth.signOut().then(() => {
                        alert("You are now logged out.")
                        loggedIn = false;
                        userName = "";
                        window.location.reload();
                    });})
                .catch((err) => {
                    console.log(err)
                    window.location.reload();
                });
        }
        else {
            console.log("logout not logged in!");
            window.location.reload();
        }
    }
    function resetTimer() {
        if (checkTimer)
        {
            if (loggedIn) {
                clearTimeout(time);
                console.log("Timer Reset!")
                time = setTimeout(logout, 900000)
            }
            else {
                console.log("reset not logged in!");
                Auth.currentAuthenticatedUser({
                    bypassCache: false // Optional, By default is false. If set to true, this call will send a request to Cognito to get the latest user data
                })
                    .then((user) => {
                        console.log(user);
                        var authTime = user["signInUserSession"]["accessToken"]["payload"]["auth_time"];
                        // var exp = user["signInUserSession"]["accessToken"]["payload"]["exp"];
                        // // console.log(user["signInUserSession"]["accessToken"]["payload"]["auth_time"]);
                        // // console.log(user["signInUserSession"]["accessToken"]["payload"]["exp"]);
                        // // console.log(currTime)
                        var timeDiff = currTime - (authTime * 1000)
                        console.log(timeDiff)
                        if (timeDiff > 50000) {
                            window.location.reload();
                        }
                        
                    })
                    .catch((err) => {
                        console.log(err);
                        checkTimer = false;
                        console.log("test")
                        window.location.reload();
                    });
            } 
        }
       
        // 1000 milliseconds = 1 second 1200000 = 20 minutes 300000 = 5 minutes
    }
};
function formatBytes(a, b = 2, k = 1024) {
    let d = Math.floor(Math.log(a) / Math.log(k));
    return 0 === a ? "0 Bytes" : parseFloat((a / Math.pow(k, d)).toFixed(Math.max(0, b))) + " " + ["Bytes", "KB", "MB", "GB", "TB", "PB", "EB", "ZB", "YB"][d];
}

const appLayoutLabels = {
    navigation: 'Side navigation',
    navigationToggle: 'Open side navigation',
    navigationClose: 'Close side navigation',
    notifications: 'Notifications',
    tools: 'Help panel',
    toolsToggle: 'Open help panel',
    toolsClose: 'Close help panel'
};
 
 const ServiceNavigation = () => {
    const location = useLocation();
    let navigate = useNavigate();

    function onFollowHandler(event) {
        if (!event.detail.external) {
            event.preventDefault();
            navigate(event.detail.href);
        }
    }
//side navigation information
    return (
       <SideNavigation
             activeHref={location.pathname}
            header={{href: "/", text: "PEAS-E Downloader Tool"}}
            onFollow={onFollowHandler}
            items={[
                {
                    type: "link", 
                    text: "Logout", 
                    href: "/login"
                },
                {
                    type: "divider"
                },
                /*{
                    type: "link",
                    text: "Test",
                    href: "Michael.J.Walker@hotmail.com",
                    external: false
                }*/
            ]} 
        />
        );
} 
//notice board
const HelpNavigation = () => {
    return (
        <HelpPanel
            footer={
                <div>
                    <h1>PEAS-E Downloader Tool</h1>
                    <i>Delivering your data needs, whenever and wherever you are</i>
                </div>
            }
            header={<h2>Notice Board</h2>}
        >
            <div>
                <p>
                    Please check back here from time to time for upcoming outages, <i>new features</i>, updates, <u><b>acceptable files</b></u> and other useful information.
                </p>
                <h4>Acceptable File Types</h4>
                <p>
                    <pre>
                        <code>{".txt, .xml, .csv, .dwg, .rvt, .zip"}</code>
                    </pre>
                </p>
                
                <h5>Helpful Informations</h5>
                <dl>
                    <dt>How It Works</dt>
                    <dd>Users would be able to load files from their bucket by clicking the button. Users would then be able to download files by clicking buttons that have the file name they want. </dd>
                    <dt>Notification Process</dt>
                    <dd>During the onboarding session, we associate the provided email with our notification stack. Essentially, whenever you upload an object, our backend infrastructure will send a confirmation reciept. You should see an email from <b>no-reply@goldcherrygumdrop.com</b>. If you see something else, run!</dd>
                    <dt>PEAS-E UI Information</dt>
                    <dd>This UI will automatically log you out after 15 minutes of inactivity. However, the timer resets when it picks up activity. The UI will retain the name of the objects that was successfully delivered. Refreshing the window will refresh remove it and their are no way of retrieving what was delivered.</dd>
                    <dt>ZIP Files</dt>
                    <dd>Currently, .rvt files will need to be compressed and zipped for it to be deliver up.</dd>
                </dl>
            </div>
        </HelpPanel>
    );
}
 
const Content = () => {
   
   
    const handleClick = (e) => {
        e.preventDefault();
    };
    const [listFiles, setListFiles] = useState([]);
    const handleDownload = (name) => {
        downloadBlob(identityID+'/'+ name)
        // handleLambda(identityID)
        function downloadBlob(name) {
            // Convert your blob into a Blob URL (a special url that points to an object in the browser's memory)
            const result = Storage.get(name, { download: true, expires: 300}).then((data) => {
                console.log(data);
                const blobUrl = URL.createObjectURL(data.Body);
                // Create a link element
                const link = document.createElement('a');
                // Set link's href to point to the Blob URL
                link.href = blobUrl;
                var key = name.replace(identityID+'/',"")
                link.download = key;
                
                // Append link to the body
                document.body.appendChild(link);
                // Dispatch click event on the link
                link.dispatchEvent(
                  new MouseEvent('click', {
                    bubbles: true,
                    cancelable: true,
                    view: window,
                  })
            );    
            // Remove link from body
            document.body.removeChild(link);
                    })
                .catch((err) => console.log(err));
  
            // // data.Body is a Blob
            // result.Body.text().then(string => { 
            //   // handle the String data return String 
            // });
            console.log(result)
           
        }

        }
    const handleLambda = () => {
        handleLambda(identityID)
        function handleLambda(name) {
            console.log("Lambda markap1-copyBucketUI_fn")
            var AWS = require('aws-sdk');
            AWS.config.update({region:'us-east-1'});
            Auth.currentCredentials()
                .then(credentials => {
                    const lambda = new Lambda({
                        credentials: Auth.essentialCredentials(credentials)
                    });
                    console.log(credentials)
                    var lambdaResponse =lambda.invoke({
                        FunctionName: 'markap1-copyBucketUI_fn',
                        Payload: JSON.stringify({ identityID, username: userName }),
                    }, function(err, data) {
                        if (err) {
                            event.message = err + ' query error';
                            console.log(err,event.message);
                            }
                    });
                    console.log(lambdaResponse)
                    setListFiles([])
                    Auth.currentUserCredentials().then((result) => {
                        identityID = result.identityId;
                        console.log(identityID)
                        Storage.list(identityID+'/',)
                            .then((results) => {
                                results.forEach((item) => { 
                                    var key = item.key.replace(identityID+'/',"")
                                    console.log(key)
                                    console.log(item.key)
                                    if (key != "") {
                                        setListFiles(arr => [...arr, key]);
                                    }
                                })
                            })
                    })
                })
                
            }
        }

    
    useEffect(() => { 
        Auth.currentUserCredentials().then((result) => {
        identityID = result.identityId;
        console.log(identityID)
        Storage.list(identityID+'/',)
            .then((results) => {
                results.forEach((item) => { 
                    var key = item.key.replace(identityID+'/',"")
                    console.log(key)
                    console.log(item.key)
                    if (key != "") {
                        setListFiles(arr => [...arr, key]);
                    }
                })
            })
    })
    },[])

    if(loggedIn){
        return (
            <>
            <form className='bg-white gap-2 mt-4' onSubmit={handleClick}>
                <button className='btn btn-primary gap-2 mt-3'  tabIndex="1" onClick={() => handleLambda()}> 
                    Load Files into S3
                </button>{'  '}
                { 
                  listFiles.map((val) => ( 
                    <div className="d-table gap-2 mt-3" aria-live="polite">
                        <button className='btn btn-download' tabIndex="2" onClick={() => handleDownload(val)}> 
                            {val} 
                        </button>{' '}
                    </div>
                  )) 
                } 

            </form>
            
            </>
        );
    }
    else {
        return <Navigate replace to="/login" />;
    }
};

const AppLayoutUI = () => {
    const [navigationOpen, setNavigationOpen] = useState(false);
    const [toolsOpen, setToolsOpen] = useState(true);
    let{state} =useLocation(); 
    if (state ==null) {
        return <Navigate replace to="/login" />;
    } 
    console.log(currTime)
    currTime = Date.now();
    console.log(currTime)
    inactivityTime();
    let {authLoggedIn, authUserName, user} =state;
    loggedIn = authLoggedIn;
    userName = authUserName;
    
    Auth.currentAuthenticatedUser({
                bypassCache: false // Optional, By default is false. If set to true, this call will send a request toUni Cognito to get the latest user data
            })
                .then((user) => {
                    console.log(user);
                    var authTime = user["signInUserSession"]["accessToken"]["payload"]["auth_time"];
                    // var exp = user["signInUserSession"]["accessToken"]["payload"]["exp"];
                    // // console.log(user["signInUserSession"]["accessToken"]["payload"]["auth_time"]);
                    // // console.log(user["signInUserSession"]["accessToken"]["payload"]["exp"]);
                    // // console.log(currTime)
                    var timeDiff = currTime - (authTime * 1000)
                    console.log(timeDiff)
                    if (timeDiff > 50000) {
                        loggedIn = false;
                        window.location.reload();
                    }
                    
                })
                .catch((err) => {
                    console.log(err);
                    // checkTimer = false;
                    loggedIn = false;
                    // window.location.reload();
                });
    
    const navbarItemClick = e => {
        console.log(e);
        if (e.detail.id === 'signout') {
            Auth.signOut().then(() => {
                window.location.reload();
                loggedIn = false;
                userName = "";
            });
        }
    }

    useEffect(() => {  
        const onBeforeUnload = (ev) =>{
            // ev.preventDefault();
            // ev.stopPropagation();
            //ev.returnValue = false; 
            console.log("here");
            loggedIn = false;
            checkTimer = false;
            Auth.signOut().then(() => {
                alert("You are now logged out.")
                loggedIn = false;
                userName = "";
            });
            window.history.replaceState({}, document.title)
        };    
        window.addEventListener("beforeunload",onBeforeUnload)
        return () => {
            window.removeEventListener("beforeunload",onBeforeUnload)
    onBeforeUnload();
        };
    }, []);
   
       

  
    if(loggedIn){
        window.onload = function() {
        const [listFiles] = useState([]);
          listFiles.map((val) => ( 
                 {val}
             )) 
        inactivityTime();
        }
        checkTimer = true;
         return(
        <>
          <div id="navbar" style={{fontSize: 'body-l !important', position: 'sticky', top: 0, zIndex: 1002}}>
                <TopNavigation
                    identity={{
                        href: "#",
                        title: "PEAS-E Downloader Tool",
                        logo: {
                            src:
                                "data:image/svg+xml;base64,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",
                            alt: "PEAS-E Download Tool"
                        }
                    }}
                    utilities={[
                        {
                            type: "menu-dropdown",
                            text: userName,
                            description: userName,
                            iconName: "user-profile",
                            onItemClick: navbarItemClick,
                            items: [
                                {id: "signout", text: "Sign out"}
                            ]
                        }
                    ]}
                    i18nStrings={{
                        searchIconAriaLabel: "Search",
                        searchDismissIconAriaLabel: "Close search",
                        overflowMenuTriggerText: "More"
                    }}
                    className="pad-top"
                />
            </div>
            <AppLayout
                content={<Content/>}
                headerSelector='#navbar'
                navigation={<ServiceNavigation/>}
                navigationOpen={navigationOpen}
                onNavigationChange={({detail}) => setNavigationOpen(detail.open)}
                ariaLabels={appLayoutLabels}
                tools={<HelpNavigation/>}
                toolsOpen={toolsOpen}
                onToolsChange={({detail}) => setToolsOpen(detail.open)}
            />
        </>
        );
    } 
    else {
        return <Navigate replace to="/login" />;
    }
};

function App() {
    const [navigationOpen, setNavigationOpen] = useState(false);
    const [toolsOpen, setToolsOpen] = useState(true);
     const { state } = useLocation();
     //let {state} =useLocation(); let {loggedIn, userName, authenticated} =state;
    const navbarItemClick = e => {
       
        console.log(e);
        if (e.detail.id === 'signout') {
            Auth.signOut().then(() => {
                window.location.reload();
                loggedIn = false;
                userName = "";
            });
        }
    }
    window.onload = function() {
        
        console.log("start")
        inactivityTime();
    }
    return <Navigate replace to="/login" />; 
}

export {App, AppLayoutUI};
